import { useEffect, useState } from 'react'

export const usePWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null)

  useEffect(() => {
    const handler = (e: BeforeInstallPromptEvent) => {
      e.preventDefault()
      setDeferredPrompt(e)
      window.console.log('beforeinstallprompt event fired and captured')
    }

    window.addEventListener('beforeinstallprompt', handler as EventListener)
    window.console.log('beforeinstallprompt event listener added')

    return () => {
      window.removeEventListener('beforeinstallprompt', handler as EventListener)
      window.console.log('beforeinstallprompt event listener removed')
    }
  }, [])

  return { deferredPrompt, setDeferredPrompt }
}
